import AppApi from "api/App/AppApi";
import AppConstants from "global/constants/AppConstants";
import { Result } from "global/constants/AppType";
import { useAuth } from "global/context/AuthenticationContext";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { removeBase64Prefix } from "utils/format/Normalize";
import { isPaginatedData } from "utils/typeGuards/typeGuards";

const useDKTTBModel = () => {
  const { getUserInfo } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [detailDK, setDetailDK] = useState<any>();
  const [plans, setPlans] = useState<any[]>([]);
  const [resultObject, setResultObject] = useState<Result | null>(null);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [planPrice, setPlanPrice] = useState<number>(0);

  const getListHistory = async (id: string) => {
    try {
      setLoading(true);
      const response = await AppApi.getSimkitInitDetail(id);

      if (response?.code === 0) {
        const data = response.data;
        setDetailDK(data);

        await getPlan();
      } else {
        setResultObject({
          type: "error",
          message: "Simkit đã được đăng kí, Bạn đang được chuyển hướng sau 5s",
        });
        setTimeout(() => navigate(`/order/dkttb`), 5000);
      }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const getPlan = async () => {
    try {
      setLoading(true);
      const response = await AppApi.getPackage({
        limit: 100,
      });

      if (response?.data && isPaginatedData(response.data)) {
        const activePlans = response.data.items.filter(
          (plan: any) => plan.status === 0 || plan.status === "ACTIVE",
        );

        setPlans(activePlans);
      }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const onConfirm = async (info: any) => {
    try {
      setLoading(true);

      const values: any = {
        transaction_code: detailDK?.id,
        sim_base_image: removeBase64Prefix(info?.imgSim),
        id_card_front_image: removeBase64Prefix(info?.imgCccdFront),
        id_card_back_image: removeBase64Prefix(info?.imgCccdBack),
        portrait_image: removeBase64Prefix(info?.imgPortrait),
        signature_image: removeBase64Prefix(info?.imgSignature),
        plan_id: info?.plan_id,
        sim_type:
          typeof info?.sim_type === "object"
            ? info.sim_type?.value
            : info?.sim_type,
        ...(info?.serial ? { serial: info.serial } : {}),
        id_type:
          typeof info?.id_type === "object"
            ? info.id_type?.value
            : info?.id_type,
        email: info?.email,
        address: info?.address,
        title: `Đăng kí thông tin số điện thoại ${detailDK?.phone_number}`,
      };

      const response = await AppApi.getSimkitOCR(values);

      if (response?.code === 0) {
        const info: any = response.data;
        navigate(`/order/dkttb-detail/${info?.ocr_info?.transaction_code}`);
      } else {
        const message =
          response?.code === 1
            ? (response?.message ?? AppConstants.ERROR_OCCUR)
            : AppConstants.ERROR_OCCUR;
        setResultObject({ type: "error", message });
        if (response?.error?.code === 416) navigate(`/order/dkttb`);
      }
    } catch (error) {
      console.log(error);
      setResultObject({ type: "error", message: AppConstants.ERROR_OCCUR });
    } finally {
      setLoading(false);
      getUserInfo();
    }
  };

  const reload = () => {
    if (id) getListHistory(id);
  };

  useEffect(() => {
    if (id) getListHistory(id);
  }, [id]);

  return {
    plans,
    loading,
    detailDK,
    resultObject,
    totalAmount,
    planPrice,
    setTotalAmount,
    setPlanPrice,
    getListHistory,
    setResultObject,
    onConfirm,
    reload,
  };
};

export default useDKTTBModel;
